import { render, staticRenderFns } from "./GroupProtectSetting.vue?vue&type=template&id=5fca8d9e&"
import script from "./GroupProtectSetting.vue?vue&type=script&lang=js&"
export * from "./GroupProtectSetting.vue?vue&type=script&lang=js&"
import style0 from "./GroupProtectSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports